import React from 'react';
import Nodes from './components/Node'
import './App.css';

function App() {
  return (
    <div className="App">
      <Nodes />
    </div>
  );
}

export default App;
